module.exports = __webpack_public_path__ + "img/hogging.8612735f.svg";